<template>
  <div class="card">
    <h5 class="card-header text-truncate w-100">
      <span class="badge bg-info rounded-pill bx-pull-right font-size-12">
        Estados
      </span>
      Routers
    </h5>
    <div class="card-body">
      <div class="row">
        <div class="col-4 text-center">
          <router-link
            :to="{ name: 'listadoRouters', query: { en_linea: 1 } }"
            title="En linea"
          >
            <div class="avatar mx-auto">
              <div
                class="avatar-title rounded-circle bg-success bg-gradient"
                :class="en_linea <= 999 ? 'font-size-20' : 'font-size-16'"
                :title="en_linea"
              >
                {{ enLineaFormato }}
              </div>
            </div>
            <div class="text-success text-truncate w-100">
              En linea
            </div>
          </router-link>
        </div>
        <div class="col-4 text-center">
          <router-link
            :to="{
              name: 'listadoRouters',
              query: { desconectados: 1 }
            }"
            title="Desconectados"
          >
            <div class="avatar mx-auto">
              <div
                class="avatar-title rounded-circle bg-danger bg-gradient"
                :class="desconectados <= 999 ? 'font-size-20' : 'font-size-16'"
                :title="desconectados"
              >
                {{ desconectadosFormato }}
              </div>
            </div>
            <div class="text-danger text-truncate w-100">
              Desconectados
            </div>
          </router-link>
        </div>
        <div class="col-4 text-center">
          <router-link
            :to="{ name: 'listadoRouters' }"
            title="Routers"
          >
            <div class="avatar mx-auto">
              <div class="avatar-title rounded-circle bg-primary bg-gradient font-size-24">
                <i class="mdi mdi-router"></i>
              </div>
            </div>
            <div class="text-truncate w-100">
              Routers
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouterSrv from '@/services/RouterSrv.js'

export default {
  name: 'WRouters',
  data() {
    return {
      en_linea:       sessionStorage.getItem('argusblack.wrouters.en_linea')      || 0,
      desconectados:  sessionStorage.getItem('argusblack.wrouters.desconectados') || 0,
      intervals: {
        actualizacion: null
      }
    }
  },
  created() {
    var self = this

    this.actualizar()
    this.intervals.actualizacion = setInterval(function() {
      self.actualizar()
    }, 60000)
  },
  computed: {
    enLineaFormato: function() {
      return this.en_linea <= 9999 ? this.en_linea : '999+'
    },
    desconectadosFormato: function() {
      return this.desconectados <= 9999 ? this.desconectados : '999+'
    }
  },
  beforeUnmount() {
    clearInterval(this.intervals.actualizacion)
  },
  methods: {
    actualizar() {
      var self = this
      let params = { mes_actual: true }
      RouterSrv.nEnLinea(params).then(response => {
        self.en_linea = response.data
        sessionStorage.setItem('argusblack.wrouters.en_linea', self.en_linea)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje):null
        console.log(error)
      })

      RouterSrv.nDesconectados(params).then(response => {
        self.desconectados = response.data
        sessionStorage.setItem('argusblack.wrouters.desconectados', self.desconectados)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje):null
        console.log(error)
      })
    }
  }
}
</script>